export default "__VITE_PUBLIC_ASSET__ce50da85__"